var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"panel"}},[_c('myHeader'),_c('el-container',{staticClass:"main"},[_c('el-aside',{attrs:{"width":"300px"}},[_c('AsideBar')],1),_c('el-main',{staticClass:"contR"},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }